import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=12d6623b&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=12d6623b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6623b",
  null
  
)

export default component.exports